/* DOLL — comportamientos compartidos del tema. */
(function () {
  'use strict';

  /* --- Entrada al hacer scroll ------------------------------------------- */

  function initReveal() {
    var targets = document.querySelectorAll('.doll-reveal:not([data-doll-revealed])');
    if (!targets.length) return;

    var reduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.setAttribute('data-doll-revealed', '');
        el.classList.add('doll-reveal--in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('doll-reveal--in');
          entry.target.setAttribute('data-doll-revealed', '');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --- Barra de anuncio en móvil -------------------------------------------
     En escritorio los mensajes se ven todos en una fila. En móvil no caben,
     así que el CSS los apila en la misma celda y aquí vamos pasando el turno
     de uno en uno. Solo se enciende por debajo de 750px; al pasar a
     escritorio se apaga el turno y vuelven a verse todos. */

  var annTimer = null;
  var ANN_DELAY = 4000;

  function initAnnouncement() {
    if (annTimer) {
      clearInterval(annTimer);
      annTimer = null;
    }

    var list = document.querySelector('[data-doll-announcement]');
    if (!list) return;

    var items = list.querySelectorAll('.doll-announcement__item');
    if (items.length < 2) return;

    var index = 0;

    function show(i) {
      for (var n = 0; n < items.length; n++) {
        if (n === i) items[n].setAttribute('data-doll-ann-current', '');
        else items[n].removeAttribute('data-doll-ann-current');
      }
    }

    var mq = window.matchMedia('(max-width: 749px)');

    function apply() {
      if (mq.matches) {
        if (annTimer) return;
        show(index);
        annTimer = setInterval(function () {
          index = (index + 1) % items.length;
          show(index);
        }, ANN_DELAY);
      } else {
        if (annTimer) {
          clearInterval(annTimer);
          annTimer = null;
        }
        index = 0;
        show(0);
      }
    }

    apply();

    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  /* --- Header pegado arriba ------------------------------------------------
     La cabecera queda fija (position:fixed) mientras se baja la página,
     siempre visible. Tres medidas la gobiernan:

     1. top: la barra de anuncio NO es fija (se va con el scroll). Si la
        cabecera se quedara en top:0 la taparía desde el primer instante, así
        que arranca desplazada el alto de la barra y sube hasta el borde
        conforme se baja la página.

     2. --doll-header-row-h: el alto de la fila del logo. Lo usa el CSS para
        cortar el fondo: sólido hasta ahí y, de ahí hacia abajo (la fila de
        categorías), negro al 80%. El fondo es el mismo siempre, no cambia
        con el scroll; esta medida solo sigue a la fila cuando se encoge.

     3. .doll-header-spacer: reserva alto para que el contenido no salte. En
        páginas que abren con hero reserva solo la fila del logo, para que la
        foto empiece justo donde termina esa fila y la fila de categorías
        quede encima de la imagen. En el resto de páginas reserva la cabecera
        completa. */

  function initStickyHeader() {
    var header = document.querySelector('[data-doll-header]');
    var spacer = document.querySelector('[data-doll-header-spacer]');
    if (!header) return;

    var row = header.querySelector('.doll-header');
    var announcement = document.querySelector('.doll-announcement');
    var annHeight = 0;
    var heroFirst = false;

    // Las secciones desactivadas no llegan al HTML, así que basta con mirar
    // si la primera sección del contenido es el hero.
    function pageOpensWithHero() {
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (!main) return false;
      var first = main.querySelector('.shopify-section');
      return !!(first && first.querySelector('.doll-hero'));
    }

    function measure() {
      heroFirst = pageOpensWithHero();
      header.classList.toggle('doll-header--over-hero', heroFirst);

      annHeight = announcement
        ? Math.round(announcement.getBoundingClientRect().height)
        : 0;

      var rowHeight = row ? Math.ceil(row.getBoundingClientRect().height) : 0;
      header.style.setProperty('--doll-header-row-h', rowHeight + 'px');

      if (spacer) {
        spacer.style.height =
          (heroFirst ? rowHeight : Math.ceil(header.getBoundingClientRect().height)) + 'px';
      }
    }

    var ticking = false;

    function update() {
      var y = window.scrollY || window.pageYOffset;

      // La cabecera baja lo que mide la barra de anuncio y sube con el scroll.
      header.style.top = Math.max(0, annHeight - y) + 'px';

      // Solo encoge un poco la fila del logo: el fondo no cambia.
      header.classList.toggle('doll-header--scrolled', y > 24);

      ticking = false;
    }

    function refresh() {
      measure();
      update();
    }

    refresh();

    window.addEventListener('load', refresh);
    window.addEventListener('resize', refresh);

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        measure();
      });
      if (row) ro.observe(row);
      ro.observe(header);
      if (announcement) new ResizeObserver(refresh).observe(announcement);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  /* --- Menú móvil --------------------------------------------------------- */

  function initMobileNav() {
    var toggle = document.querySelector('[data-doll-nav-toggle]');
    var panel = document.querySelector('[data-doll-nav-panel]');
    if (!toggle || !panel) return;
    if (toggle.hasAttribute('data-doll-bound')) return;
    toggle.setAttribute('data-doll-bound', '');

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.toggleAttribute('hidden', !open);
      document.documentElement.classList.toggle('doll-nav-open', open);
      if (open) {
        var first = panel.querySelector('a, button');
        if (first) first.focus();
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    panel.addEventListener('click', function (event) {
      if (event.target.closest('[data-doll-nav-close]')) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  function init() {
    initReveal();
    initAnnouncement();
    initStickyHeader();
    initMobileNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de Shopify recarga secciones sin recargar la página.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
